var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'backbone', 'common/location'], function($, Backbone, location) {
  var BaseCollection;
  return BaseCollection = (function(_super) {

    __extends(BaseCollection, _super);

    function BaseCollection() {
      this.fetch = __bind(this.fetch, this);
      BaseCollection.__super__.constructor.apply(this, arguments);
    }

    BaseCollection.prototype.url = function() {
      var apiRoot, path;
      apiRoot = this.useV2BookkeepingApi ? location.v2BookkeepingApiRoot : location.apiRoot;
      if (this.path) {
        path = typeof this.path === 'function' ? this.path() : this.path;
        return apiRoot + path;
      } else {
        return apiRoot;
      }
    };

    BaseCollection.prototype.searchableFields = [];

    BaseCollection.prototype.buildSearchIndex = function(options) {
      var defaultOptions;
      if (options == null) {
        options = {};
      }
      defaultOptions = {
        keys: this.searchableFields,
        id: 'id'
      };
      return this._fuse = new Fuse(_.pluck(this.models, 'attributes'), _.defaults(options, defaultOptions));
    };

    BaseCollection.prototype.search = function(query) {
      var searchResults,
        _this = this;
      searchResults = _(this._fuse.search(query));
      return new this.constructor(this.filter(function(task) {
        return searchResults.contains(task.get('id'));
      }));
    };

    BaseCollection.prototype.fetch = function() {
      return BaseCollection.__super__.fetch.call(this, {
        xhrFields: {
          withCredentials: true
        }
      });
    };

    return BaseCollection;

  })(Backbone.Collection);
});
